import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "m-0" }
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_8 = { class: "mt-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_10 = { class: "mt-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_12 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_14 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_15 = { class: "indicator-label" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_17 = { class: "card mb-5 mb-xl-10" }
const _hoisted_18 = { class: "card-header" }
const _hoisted_19 = { class: "card-title m-0" }
const _hoisted_20 = { class: "m-0" }
const _hoisted_21 = { class: "card-body p-9" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group d-flex flex-wrap" }
const _hoisted_25 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "form-group d-flex flex-wrap" }
const _hoisted_29 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = { class: "form-group d-flex flex-wrap" }
const _hoisted_32 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_33 = { class: "mt-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "form-group d-flex flex-wrap" }
const _hoisted_38 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "form-group d-flex flex-wrap" }
const _hoisted_41 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-md-6" }
const _hoisted_44 = { class: "form-group d-flex flex-wrap" }
const _hoisted_45 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_46 = { class: "col-md-6" }
const _hoisted_47 = { class: "form-group d-flex flex-wrap" }
const _hoisted_48 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = { class: "form-group d-flex flex-wrap" }
const _hoisted_52 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_53 = { class: "col-md-6" }
const _hoisted_54 = { class: "form-group d-flex flex-wrap" }
const _hoisted_55 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col-md-6" }
const _hoisted_58 = { class: "form-group d-flex flex-wrap" }
const _hoisted_59 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_60 = { class: "col-md-6" }
const _hoisted_61 = { class: "form-group d-flex flex-wrap" }
const _hoisted_62 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "col-md-6" }
const _hoisted_65 = { class: "form-group d-flex flex-wrap" }
const _hoisted_66 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_67 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_69 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_70 = { class: "indicator-label" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_72 = { class: "card-header" }
const _hoisted_73 = { class: "card-title m-0" }
const _hoisted_74 = { class: "fw-boldest m-0" }
const _hoisted_75 = { class: "card-body p-9" }
const _hoisted_76 = { class: "mb-0" }
const _hoisted_77 = {
  key: 1,
  class: "summaries-td"
}
const _hoisted_78 = {
  key: 1,
  class: "summaries-td"
}
const _hoisted_79 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { class: "indicator-label" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_84 = { class: "indicator-progress" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MBTaggings = _resolveComponent("MBTaggings")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      onSubmit: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      rules: _ctx.rules,
      model: _ctx.formData,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("merchants.fulfillmentToGermany")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_MBTaggings, {
              ref: "germanyTaggingsRef",
              "tagging-config": _ctx.to_germanyConfig,
              "tagging-items": _ctx.to_germanySource,
              "tagging-values": _ctx.to_germanyValues
            }, null, 8, ["tagging-config", "tagging-items", "tagging-values"]),
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("merchants.fulfillmentToChina")), 1),
            _hoisted_7,
            _createVNode(_component_MBTaggings, {
              ref: "chinaTaggingsRef",
              "tagging-config": _ctx.to_chinaConfig,
              "tagging-items": _ctx.to_chinaSource,
              "tagging-values": _ctx.to_chinaValues
            }, null, 8, ["tagging-config", "tagging-items", "tagging-values"]),
            _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t("merchants.fulfillmentToHKMacau")), 1),
            _hoisted_9,
            _createVNode(_component_MBTaggings, {
              ref: "hk_macauTaggingsRef",
              "tagging-config": _ctx.to_hk_macauConfig,
              "tagging-items": _ctx.to_hk_macauSource,
              "tagging-values": _ctx.to_hk_macauValues
            }, null, 8, ["tagging-config", "tagging-items", "tagging-values"]),
            _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t("merchants.warehouse")), 1),
            _hoisted_11,
            _createVNode(_component_MBTaggings, {
              ref: "warehouseTaggingsRef",
              "tagging-items": _ctx.warehouseSource,
              "tagging-values": _ctx.warehouseValues
            }, null, 8, ["tagging-items", "tagging-values"])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary align-self-center me-2",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
            }, [
              _hoisted_13,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("common.backToList")), 1)
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, [
                _hoisted_16,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("common.saveChanges")), 1)
              ])
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.$t("merchants.serviceCoverage")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("merchants.serviceStatus")), 1),
                  _createVNode(_component_el_form_item, { prop: "service_status" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.formData.service_status,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.service_status) = $event)),
                        "active-value": 1,
                        "inactive-value": 0
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("merchants.fulfillmentForDirectSellingOrder")), 1),
                  _createVNode(_component_el_form_item, { prop: "fulfillment_affiliate_order" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.formData.fulfillment_affiliate_order,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.fulfillment_affiliate_order) = $event)),
                        "active-value": 1,
                        "inactive-value": 0
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("merchants.fulfillmentForResellingOrder")), 1),
                  _createVNode(_component_el_form_item, { prop: "fulfillment_b2b_order" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.formData.fulfillment_b2b_order,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.fulfillment_b2b_order) = $event)),
                        "active-value": 1,
                        "inactive-value": 0
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("h3", _hoisted_33, _toDisplayString(_ctx.$t("merchants.serviceLevelB2BOrder")), 1),
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("merchants.orderManagement")), 1),
                  _createVNode(_component_el_form_item, { prop: "order_management" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.order_management,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.order_management) = $event)),
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Full Service",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "Data Extend",
                            value: 20
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inherit",
                            value: 30
                          }),
                          _createVNode(_component_el_option, {
                            label: "Disable",
                            value: 40
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("merchants.euPickUpService")), 1),
                  _createVNode(_component_el_form_item, { prop: "eu_shipment" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.eu_shipment,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.eu_shipment) = $event)),
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Full Service",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "Data Extend",
                            value: 20
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inherit",
                            value: 30
                          }),
                          _createVNode(_component_el_option, {
                            label: "Disable",
                            value: 40
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t("merchants.transitQCWarehouse")), 1),
                  _createVNode(_component_el_form_item, { prop: "transit_qc_warehouse" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"},
                        modelValue: _ctx.formData.transit_qc_warehouse,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.transit_qc_warehouse) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Full Service",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "Data Extend",
                            value: 20
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inherit",
                            value: 30
                          }),
                          _createVNode(_component_el_option, {
                            label: "Disable",
                            value: 40
                          })
                        ]),
                        _: 1
                      }, 8, ["placeholder", "modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t("merchants.overseasShipment")), 1),
                  _createVNode(_component_el_form_item, { prop: "overseas_shipment" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.overseas_shipment,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.overseas_shipment) = $event)),
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Full Service",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "Data Extend",
                            value: 20
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inherit",
                            value: 30
                          }),
                          _createVNode(_component_el_option, {
                            label: "Disable",
                            value: 40
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t("merchants.exportCustomDeclaration")), 1),
                  _createVNode(_component_el_form_item, { prop: "export_custom_declaration" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.export_custom_declaration,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.export_custom_declaration) = $event)),
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Full Service",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "Data Extend",
                            value: 20
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inherit",
                            value: 30
                          }),
                          _createVNode(_component_el_option, {
                            label: "Disable",
                            value: 40
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t("merchants.importCustomDeclaration")), 1),
                  _createVNode(_component_el_form_item, { prop: "import_custom_declaration" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.import_custom_declaration,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.import_custom_declaration) = $event)),
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Full Service",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "Data Extend",
                            value: 20
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inherit",
                            value: 30
                          }),
                          _createVNode(_component_el_option, {
                            label: "Disable",
                            value: 40
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.$t("merchants.bondedWarehouse")), 1),
                  _createVNode(_component_el_form_item, { prop: "bonded_warehouse" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.bonded_warehouse,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.bonded_warehouse) = $event)),
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Full Service",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "Data Extend",
                            value: 20
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inherit",
                            value: 30
                          }),
                          _createVNode(_component_el_option, {
                            label: "Disable",
                            value: 40
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.$t("merchants.cnShipment")), 1),
                  _createVNode(_component_el_form_item, { prop: "cn_shipment" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.cn_shipment,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.cn_shipment) = $event)),
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Full Service",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "Data Extend",
                            value: 20
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inherit",
                            value: 30
                          }),
                          _createVNode(_component_el_option, {
                            label: "Disable",
                            value: 40
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.$t("merchants.exceptionHandling")), 1),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.exception_handling,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.exception_handling) = $event)),
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Full Service",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "Data Extend",
                            value: 20
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inherit",
                            value: 30
                          }),
                          _createVNode(_component_el_option, {
                            label: "Disable",
                            value: 40
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary align-self-center me-2",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
            }, [
              _hoisted_68,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("common.backToList")), 1)
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_69, [
              _createElementVNode("span", _hoisted_70, [
                _hoisted_71,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("common.saveChanges")), 1)
              ])
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["rules", "model"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pathData, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "card mb-5 mb-xl-10",
        key: item.value
      }, [
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("h3", _hoisted_74, _toDisplayString(item.name), 1)
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_75, [
          _createElementVNode("div", _hoisted_76, [
            _createVNode(_component_el_table, {
              data: item.rows,
              style: {"width":"100%"},
              class: "table-summaries",
              size: "small",
              "min-width": "220",
              "show-summary": "",
              "summary-method": _ctx.getSummaries
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('merchants.pathNo'),
                  width: "80",
                  type: "index"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('merchants.pathNode'),
                  prop: "name"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('merchants.durationMin')
                }, {
                  default: _withCtx(({ row }) => [
                    (row.can_custom_value == 1)
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          modelValue: row.duration_min,
                          "onUpdate:modelValue": ($event: any) => ((row.duration_min) = $event),
                          modelModifiers: { number: true },
                          type: "number",
                          size: "small",
                          min: "0",
                          class: _normalizeClass({
                    table_error:
                      _ctx.verifyPath == item.path_key &&
                      (row.duration_min === '' || row.duration_min === null),
                  })
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(row.duration_min), 1))
                  ]),
                  _: 2
                }, 1032, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('merchants.durationMax'),
                  prop: "duration_max"
                }, {
                  default: _withCtx(({ row }) => [
                    (row.can_custom_value == 1)
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          modelValue: row.duration_max,
                          "onUpdate:modelValue": ($event: any) => ((row.duration_max) = $event),
                          modelModifiers: { number: true },
                          type: "number",
                          size: "small",
                          min: "0",
                          class: _normalizeClass({
                    table_error:
                      _ctx.verifyPath == item.path_key &&
                      (row.duration_max === '' || row.duration_max === null),
                  })
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_78, _toDisplayString(row.duration_max), 1))
                  ]),
                  _: 2
                }, 1032, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('merchants.externalExpenses'),
                  prop: "external_expenses",
                  align: "right"
                }, null, 8, ["label"])
              ]),
              _: 2
            }, 1032, ["data", "summary-method"])
          ])
        ])), [
          [_directive_loading, _ctx.loadingPath && _ctx.verifyPath == item.path_key]
        ]),
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary align-self-center me-2",
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
          }, [
            _hoisted_80,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("common.backToList")), 1)
          ]),
          _withDirectives((_openBlock(), _createElementBlock("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: ($event: any) => (_ctx.updatePathTable(item.path_key, item.rows))
          }, [
            _createElementVNode("span", _hoisted_82, [
              _hoisted_83,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("common.saveChanges")), 1)
            ]),
            _createElementVNode("span", _hoisted_84, [
              _createTextVNode(_toDisplayString(_ctx.$t("common.pleaseWait")) + " ", 1),
              _hoisted_85
            ])
          ], 8, _hoisted_81)), [
            [_directive_auth, { auth: ['update'] }]
          ])
        ])
      ]))
    }), 128))
  ], 64))
}